export const getVideoPosterSrc = ({
  src,
  sanityDataset,
  sanityProjectId,
}: {
  src?: string;
  sanityDataset?: string;
  sanityProjectId?: string;
}) => {
  const noPoster = undefined;
  if (!src) {
    return noPoster;
  }

  try {
    const newUrlVideoSrc = new URL(src);

    if (!newUrlVideoSrc) {
      return noPoster;
    }

    const claudinaryHostname = 'res.cloudinary.com';
    const imagesPumaHostname = 'images.puma.com';
    const cdnSanityHostname = 'cdn.sanity.io';

    const defaultCloudName = 'puma-test';

    let cloudName = defaultCloudName;

    if (newUrlVideoSrc?.hostname === claudinaryHostname) {
      cloudName = newUrlVideoSrc?.pathname?.split('/')?.[1] || defaultCloudName;
    }

    if (!cloudName?.includes('puma')) {
      cloudName = defaultCloudName;
    }

    const videoId = newUrlVideoSrc?.pathname?.split('/')?.pop() || '';
    const protocol = newUrlVideoSrc?.protocol;

    const posterWidth = '';

    if (
      newUrlVideoSrc?.hostname === claudinaryHostname ||
      newUrlVideoSrc?.hostname === cdnSanityHostname
    ) {
      const projectId = sanityProjectId || 'qa41whrn';
      const environment = sanityDataset || 'dev';

      const videoExtension = 'mp4';

      const cdnSanityIoUrl = `${protocol}//${cdnSanityHostname}/files/${projectId}/${environment}/${videoId}${
        !!videoId?.includes(videoExtension) ? '' : `.${videoExtension}`
      }`;

      return `${protocol}//${claudinaryHostname}/${cloudName}/video/fetch/f_jpg,so_0${posterWidth}/${cdnSanityIoUrl}`;
    }

    if (newUrlVideoSrc?.hostname === imagesPumaHostname) {
      return `${protocol}//${imagesPumaHostname}/video/upload/so_0s/cms/videos/${videoId}.jpg`;
    }

    return noPoster;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error parsing video URL:', error);

    return noPoster;
  }
};
